import { useUser } from '@/hooks/useUser'
import { UserSetup } from './UserSetup'
import { Navbar } from './Navbar'
import { Footer } from './Footer'
import { LoadingSpinner } from './LoadingSpinner'

interface AppWrapperProps {
  children: React.ReactNode
}

export function AppWrapper({ children }: AppWrapperProps) {
  const { user, loading, saveUser } = useUser()

  const handleUserComplete = (name: string, avatar: string) => {
    saveUser({ name, avatar })
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  if (!user) {
    return <UserSetup onComplete={handleUserComplete} />
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  )
}
